var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"min-h-300"},[_c('div',{staticClass:"center"},[_c('h3',{staticClass:"page-title"})])])
}]

export { render, staticRenderFns }